// The database stores the platform as "Twitter" (a shared collection also used by campaigns,
// vendors and existing reports), but the product calls it X. This only changes what the user
// SEES — code that compares or looks up by platform name must keep using the stored value.
export const displayPlatformName = (name) =>
  typeof name === "string" && name.trim().toLowerCase() === "twitter" ? "X" : name;
